"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const chip_1 = require("react-toolbox/lib/chip");
const state_1 = require("../state");
const styles = __importStar(require("./content.css"));
const sidebar_1 = __importDefault(require("./sidebar"));
class Content extends React.Component {
    constructor() {
        super(...arguments);
        this.componentDidMount = () => {
            this.props.init();
        };
        this.genreToChip = (genre, active) => {
            return (React.createElement(chip_1.Chip, { deletable: active, onDeleteClick: () => active && this.props.reset() },
                React.createElement("a", { href: "#", onClick: () => this.props.filter(genre) }, genre)));
        };
        this.chips = () => {
            const { genres } = this.props;
            if (genres === undefined) {
                return null;
            }
            if (genres.active !== null) {
                return [
                    this.genreToChip(genres.active, true),
                    ...Array(...genres.others.values()).map((genre) => this.genreToChip(genre, false)),
                ];
            }
            else {
                return [
                    ...Array(...genres.others.values()).map((genre) => this.genreToChip(genre, false)),
                ];
            }
        };
    }
    render() {
        return (React.createElement("div", { className: styles.flexContainer },
            React.createElement("div", { className: styles.main },
                React.createElement("div", { id: "map", className: styles.map }),
                React.createElement("div", { className: styles.genres }, this.chips())),
            React.createElement("div", { className: styles.sideBar },
                React.createElement(sidebar_1.default, null))));
    }
}
const mapStateToProps = (state) => {
    return {
        genres: state.genres,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        filter: (visibleGenre) => dispatch(state_1.actions.filter(visibleGenre)),
        init: () => dispatch(state_1.actions.init()),
        reset: () => dispatch(state_1.actions.reset()),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(Content);
